import React, { useState, useEffect, useRef, useCallback } from 'react';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';
import { Label, Grid, SectionHeader, PageHeader, css, Toast, MontoInput } from '../components/UI';
import { validarCLABE, hoyISO } from '../utils';
import { Modal } from '../components/UI';

const ACCENT_DEFAULT = '#ff541c'; // naranja Selectshop (hex: se le concatena opacidad)

// Motivos que se ofrecen si el catálogo de nómina aún no responde
const MOTIVOS_FALLBACK = [
  'GASTOS DE OPERACIÓN / DISTRIBUCION','SUELDOS Y SALARIOS','ASIMILADOS A SALARIOS',
  'HORAS EXTRAS DOBLES','HORAS EXTRAS TRIPLES','BONOS','AGUINALDO','VACACIONES',
  'PRIMA VACACIONAL','PRIMAS DE ANTIGÜEDAD','PRIMA DOMINICAL','VALES DE DESPENSA',
  'AYUDA DE COMEDOR','FONDO DE AHORRO','CAJA DE AHORRO','DIAS FEST/DESC.LAB',
  'COMISIONES','APOYO DE TRANSPORTE','GRATIFICACIONES','INDEMNIZACIONES',
  'PREVISIÓN SOCIAL','CUOTAS AL IMSS','APORTACIONES AL SAR','APORTACIONES AL INFONAVIT',
  'IMPUESTO SOBRE NOMINA','PREMIO DE PUNTUALIDAD','PREMIO DE ASISTENCIA',
  'PERMISO CON GOCE DE SUELDO','ASESORIAS Y CAPACITACIONES','CAPACITACIÓN AL PERSONAL',
  'CURSOS','CUOTAS SINDICALES','ASESORIA','SERVICIOS BASICOS','ENERGÍA ELÉCTRICA',
  'AGUA','TELEFONO LOCAL','INTERNET','TELEFONIA MOVIL','SERVICIOS MEDICOS',
  'SUMINISTRO DE GAS','HONORARIOS Y ASIMILADOS','HONORARIOS PF','HONORARIOS PM',
  'INSUMOS Y EMPAQUES','CAJAS','PLAYO','CINTAS','TARIMAS','ETIQUETAS','BOLSAS',
  'BURBUJA','CARGADORES','MICAS','BATERIAS','INSUMOS MARKETING','OTRAS REFACCIONES',
  'INSUMOS DE ASEO','DESPENSA','LIMPIEZA','BOTIQUIN','MENSAJERIA Y PAQUETERIA',
  'MENSAJERIA','GUIAS','PAPELERÍA Y ARTÍCULOS DE OFICINA','PAPELERIA Y ARTICULOS DE OFICINA',
  'SEGUROS Y FIANZAS','SEGUROS','FIANZAS','SEGUROS GMM','SEGUROS AUTOS',
  'SEGUROS DE TRANSPORTE DE MERCANCIAS','VIATICOS VENDEDORES','PASAJE AUTOBUS',
  'BOLETO DE AVION','HOSPEDAJE','PEAJES / CASETAS','ALIMENTOS','COMBUSTIBLES',
  'PASAJES MENORES','ESTACIONAMIENTO','VIATICOS EN GENERAL','VIATICOS DIRECCION',
  'RECLUTAMIENTO','FLETES Y ACARREOS','FLETES','MANIOBRAS','VIGILANCIA Y MONITOREO',
  'CUSTODIAS','MONITOREO','VIGILANCIA','ALARMAS','GEOLOCALIZACION GPS','ESCOLTAS',
  'CAMARAS DE SEGURIDAD','UNIFORMES DE TRABAJO','PLAYERAS','PANTALONES','BOTAS',
  'CASCOS / LENTES / GUANTES','BORDADOS','SUDADERAS','IMPUESTOS Y DERECHOS','PREDIAL',
  'TENENCIA','VERIFICACION','RECARGOS FISCALES','MULTAS','DERECHOS','ARRENDAMIENTO',
  'RENTA DE NAVES INDUSTRIALES','RENTA DE IMPRESORAS','DISPENSADOR DE AGUA',
  'RENTA DE MONTACARGAS','RENTA LOCAL COMERCIAL','RENTA DE EQUIPO DE COMPUTO',
  'RESTREGADORA DE PISOS','DISPENSADOR DE CAFE','RENTA DE OFICINAS','LICENCIAS Y SOFTWARE',
  'TIMBRES','LICENCIAS','SOFTWARE','MANTENIMIENTO EQUIPO DE TRANSPORTE',
  'MANTENIMIENTO EQUIPO DE COMPUTO','MANTENIMIENTO EQUIPO DE OFICINA',
  'MANTENIMIENTO EQUIPO DE MOBILIARIO','GASTOS DE FIN DE AÑO','COMIDA BUEN FIN',
  'COMIDA HOT SALE','PASTEL DE CUMPLEAÑOS','OTRAS CELEBRACIONES','NO DEDUCIBLES',
  'IVA AUTO','ALIMENTOS NO DEDUCIBLES','COMBUSTIBLES Y LUBRICANTES NO DEDUCIBLES',
  'UBER NO DEDUCIBLES','NO DEDUCIBLES (SIN REQUISITOS FISCALES)',
  'RECOLECCIÓN DE BASURA NO DEDUCIBLE','ACTUALIZACIONES','PROPINAS',
  'SIN REQUISITOS FISCALES','DONATIVOS NO DEDUCIBLES','COMISIONES VENDEDORES',
  'COMISIONES BANCARIAS','COMISIONES ML','COMISIONES AMAZON','COMISIONES WALMART',
  'COMISIONES SI VALE','COMISIONES ADUANERA','COMISIONES LIVERPOOL',
  'COMBUSTIBLES Y LUBRICANTES','DONATIVOS Y AYUDAS','DONATIVOS','CONTROL Y PREVENCION',
  'FUMIGACION','EXTINTORES','MAQUILA','ARTICULOS PARA DESPENSA','FRUTA Y VERDURAS',
  'AGUA EMBOTELLADA O REFRESCOS','CAFÉ // INFUSIONES','ABARROTES KOSHER',
  'HERRAMIENTAS DE TRABAJO','FAJA LUMBAR DE SEGURIDAD','GUANTES PARA TRABAJO RUDO',
  'PLATAFORMA DE SURTIDO','ESCALERA TIPO AVION','PATIN HIDRAHULICO / ELCTRICO',
  'MATERIAL ELECTRICO E ILUMINACION','CONOS DE IDENTIFICACION OD',
  'PROPAGANDA Y PUBLICIDAD','MARKETING DIGITAL','PUBLICIDAD IMPRESA','MERCHANDISING',
  'LIMPIEZA DE OFICINA / AREAS COMUNES','GASTOS DE CERTIFICADOS NOM','CERTIFICADOS NOM',
  'GASTOS PROVISIONADOS','GASTOS PROVISONADOS','GASTOS DE VENTA','FLETES Y MANIOBRAS',
  'GASTOS DE ADMINISTRACION','DEPRECIACION DE PLANTA Y EQUIPO','DEPRECIACION DE EDIFICIOS',
  'DEPRECIACION EQUIPO DE TRANSPORTE','DEPRECIACION EQUIPO DE COMPUTO',
  'DEPRECIACION DE EQUIPO DE OFICINA','DEPRECIACION DE MAQUINARIA Y EQUIPO',
  'AMORTIZACION DE GASTOS DIFERIDOS','AMORTIZACION DE PATENTES Y MARCAS',
  'AMORTIZACION DE GASTOS DE INSTALACION',
];

function MotivoSearch({ value, onChange, hasError, motivos }) {
  const lista = motivos?.length ? motivos : MOTIVOS_FALLBACK;
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);
  const filtered = value.length > 0
    ? lista.filter(m => m.toLowerCase().includes(value.toLowerCase()))
    : lista;

  useEffect(() => {
    const h = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div ref={wrap} style={{ position: 'relative' }}>
      <input
        value={value}
        placeholder="Escribe o selecciona el motivo de pago..."
        onChange={e => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        style={css.input(hasError)}
      />
      {open && filtered.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
          background: 'var(--panel)', border: '1px solid var(--hair)', borderRadius: 10,
          boxShadow: '0 12px 32px rgba(15,23,42,0.14)', maxHeight: 220, overflowY: 'auto', marginTop: 4,
        }}>
          {filtered.map((m, i) => (
            <div key={m} onMouseDown={() => { onChange(m); setOpen(false); }}
              style={{
                padding: '9px 14px', cursor: 'pointer', fontSize: 13,
                borderBottom: i < filtered.length - 1 ? '1px solid var(--hair-soft)' : 'none',
                color: 'var(--ink-soft)',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,84,28,0.04)'; e.currentTarget.style.color = '#d63500'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--ink-soft)'; }}>
              {m}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ProveedorSearch({ value, onSelect }) {
  const [query, setQuery] = useState(value || '');
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  const wrap = useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);

  const search = useCallback(async (q) => {
    if (!q || q.length < 2) { setResults([]); return; }
    setLoading(true);
    try { const d = await api.get(`/catalogo-finiquitos?q=${encodeURIComponent(q)}`); setResults(d.items || []); }
    catch { setResults([]); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { clearTimeout(timer.current); timer.current = setTimeout(() => search(query), 280); return () => clearTimeout(timer.current); }, [query, search]);
  useEffect(() => {
    const h = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div ref={wrap} style={{ position: 'relative' }}>
      {/* Solo permite seleccionar del catálogo: escribir aquí filtra resultados, nunca fija el valor por sí solo */}
      <input value={query} placeholder="Escribe para buscar finiquito en el catálogo..."
        onChange={e => { const v = e.target.value; setQuery(v); setOpen(true); if (value) onSelect(null); }}
        onFocus={() => setOpen(true)}
        style={css.input(false)}
      />
      {open && (results.length > 0 || loading) && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999, background: 'rgba(255,255,255,0.82)', border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, boxShadow: '0 12px 32px rgba(15,23,42,0.14)', maxHeight: 260, overflowY: 'auto', marginTop: 4 }}>
          {loading && <div style={{ padding: '10px 14px', color: 'var(--glass)', fontSize: 13 }}>Buscando...</div>}
          {results.map((p, i) => (
            <div key={p._id || i} onMouseDown={() => { onSelect(p); setOpen(false); }}
              style={{ padding: '9px 14px', cursor: 'pointer', borderBottom: i < results.length - 1 ? '1px solid var(--hair-soft)' : 'none' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,84,28,0.04)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>{p.nombre}</div>
              {p.banco && <div style={{ fontSize: 11, color: 'var(--glass)', marginTop: 1 }}>{p.banco} · {p.clabe || '—'}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Editor de conceptos del finiquito: varios motivos, cada uno con monto y si suma o
// resta al neto (aguinaldo, vacaciones, prima… menos ISR). Igual que en la solicitud
// de nómina, de la que este formulario toma el catálogo de motivos.
function ConceptosNomina({ conceptos, onChange, motivos, hasError }) {
  const upd = (i, field, val) => onChange(conceptos.map((c, idx) => idx === i ? { ...c, [field]: val } : c));
  const add = () => onChange([...conceptos, { motivo: '', monto: '', operacion: 'suma' }]);
  const remove = (i) => { if (conceptos.length <= 1) return; onChange(conceptos.filter((_, idx) => idx !== i)); };
  const total = conceptos.reduce((s, c) => s + (parseFloat(c.monto) || 0) * (c.operacion === 'resta' ? -1 : 1), 0);
  const fmt = n => `$${n.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;
  const COLS = '116px 1fr 150px 34px';
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: COLS, gap: 6, marginBottom: 4 }}>
        {['Operación', 'Motivo de pago', 'Monto ($)', ''].map((h, i) => (
          <div key={i} style={{ fontSize: 10, fontWeight: 700, color: 'var(--glass)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</div>
        ))}
      </div>
      {conceptos.map((c, i) => {
        const montoErr  = hasError && (!c.monto || isNaN(parseFloat(c.monto)) || parseFloat(c.monto) <= 0);
        const motivoErr = hasError && !c.motivo?.trim();
        const resta = c.operacion === 'resta';
        return (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: COLS, gap: 6, marginBottom: 6, alignItems: 'start' }}>
            <button onClick={() => upd(i, 'operacion', resta ? 'suma' : 'resta')} title="Alterna entre sumar y restar este concepto" style={{
              padding: '9px 6px', borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Inter, sans-serif',
              border: `1.5px solid ${resta ? 'rgba(239,68,68,0.4)' : 'rgba(22,163,74,0.4)'}`,
              background: resta ? 'rgba(239,68,68,0.10)' : 'rgba(22,163,74,0.10)',
              color: resta ? '#dc2626' : '#15803d',
            }}>{resta ? '➖ Resta' : '➕ Suma'}</button>
            <MotivoSearch value={c.motivo} onChange={v => upd(i, 'motivo', v)} hasError={motivoErr} motivos={motivos} />
            <MontoInput value={c.monto} onChange={v => upd(i, 'monto', v)} err={montoErr} />
            <button onClick={() => remove(i)} disabled={conceptos.length <= 1} style={{
              borderRadius: 7, border: '1px solid rgba(239,68,68,0.28)', background: 'rgba(239,68,68,0.10)',
              color: 'var(--danger)', cursor: conceptos.length <= 1 ? 'not-allowed' : 'pointer',
              fontSize: 14, opacity: conceptos.length <= 1 ? 0.3 : 1, fontFamily: 'Inter, sans-serif',
            }}>🗑</button>
          </div>
        );
      })}
      <button onClick={add} style={{
        padding: '5px 14px', borderRadius: 7, fontSize: 12, fontWeight: 600,
        border: '1.5px dashed var(--hair)', background: 'var(--hair-soft)', color: 'var(--glass)',
        cursor: 'pointer', marginTop: 2, fontFamily: 'Inter, sans-serif',
      }}>+ Agregar concepto</button>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', gap: 8, marginTop: 8 }}>
        <span style={{ fontSize: 10, color: 'var(--glass)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Neto del finiquito</span>
        <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', fontFamily: 'Geist Mono, monospace' }}>{fmt(total)}</span>
      </div>
      {hasError && <div style={{ color: 'var(--danger)', fontSize: 11, marginTop: 5 }}>Cada concepto necesita motivo y un monto mayor a cero</div>}
    </div>
  );
}

export default function NuevaFiniquito({ onCreated }) {
  const { user } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [sucursalesAll, setSucursalesAll] = useState([]);
  const [centros, setCentros] = useState([]);
  const [motivosCatalogo, setMotivosCatalogo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [errors, setErrors] = useState({});
  // Conceptos del finiquito (mismo formato que la solicitud de nómina)
  const [conceptos, setConceptos] = useState([{ motivo: '', monto: '', operacion: 'suma' }]);
  // Archivos que se suben al expediente en cuanto se crea la solicitud
  const [adjuntos, setAdjuntos] = useState([]);
  const pdfInputRef = useRef(null);

  const [form, setForm] = useState({
    empresa: '', sucursal: '', centroCostos: '', direccion: '',
    proveedor: '', rfcProveedor: '', banco: '', clabe: '', cuenta: '', moneda: 'MXN',
    fechaSolicitud: hoyISO(),
    formaPago: 'TRANSFERENCIA ELECTRÓNICA', tipoPago: 'Programado', motivoPago: '', observaciones: '',
  });

  useEffect(() => {
    api.get('/empresas').then(all => {
      if (user?.rol === 'solicitante' && user?.empresas?.length) {
        const propias = all.filter(e => user.empresas.includes(e.nombre));
        setEmpresas(propias);
        if (propias.length === 1) setForm(f => ({ ...f, empresa: propias[0].nombre }));
      } else {
        setEmpresas(all);
      }
    }).catch(() => {});
    api.get('/sucursales').then(setSucursalesAll).catch(() => {});
    // El finiquito se desglosa con los mismos motivos que la nómina
    api.get('/motivos-nomina').then(ms => setMotivosCatalogo(ms.map(m => m.nombre))).catch(() => {});
  }, [user]);

  // Cargar centros de costos de la colección CentroCostos filtrada por sucursal
  useEffect(() => {
    if (!form.sucursal) { setCentros([]); return; }
    api.get(`/centros?sucursal=${encodeURIComponent(form.sucursal)}`)
      .then(list => setCentros(
        user?.rol === 'solicitante' && user?.centrosCostos?.length
          ? list.filter(c => user.centrosCostos.includes(c.nombre))
          : list
      ))
      .catch(() => setCentros([]));
  }, [form.sucursal]);

  const empresaObj = empresas.find(e => e.nombre === form.empresa);
  // Acento fijo: el color NO cambia al seleccionar empresa
  const accent = ACCENT_DEFAULT;

  // Sucursales filtradas por compañía; si la empresa no tiene asignadas, muestra todas
  const sucursalesBase = empresaObj?.sucursales?.length
    ? sucursalesAll.filter(s => empresaObj.sucursales.includes(s.nombre))
    : sucursalesAll;
  // Si el solicitante tiene sucursales asignadas, acota a ellas
  const sucursalesFiltradas = (user?.rol === 'solicitante' && user?.sucursales?.length)
    ? sucursalesBase.filter(s => user.sucursales.includes(s.nombre))
    : sucursalesBase;

  // Neto del finiquito: los conceptos suman o restan (el servidor lo recalcula igual)
  const totalBase = Math.round(conceptos.reduce(
    (s, c) => s + (parseFloat(c.monto) || 0) * (c.operacion === 'resta' ? -1 : 1), 0) * 100) / 100;

  const handleAdjuntarPDF = (fileList) => {
    const files = Array.from(fileList || []);
    if (files.length) setAdjuntos(a => [...a, ...files]);
    if (pdfInputRef.current) pdfInputRef.current.value = '';
  };

  // Sube los adjuntos al expediente de la solicitud recién creada
  const subirAdjuntos = async (solId) => {
    if (!adjuntos.length) return;
    try {
      for (let i = 0; i < adjuntos.length; i += 10) {
        const fd = new FormData();
        adjuntos.slice(i, i + 10).forEach(f => fd.append('archivos', f));
        await api.upload(`/finiquitos/${solId}/comprobantes`, fd);
      }
      setAdjuntos([]);
    } catch (e) { toast_(`Solicitud creada, pero falló la subida de archivos: ${e.message}`, 'error'); }
  };

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); if (errors[k]) setErrors(e => ({ ...e, [k]: false })); };

  const handleEmpresa = (nombre) => {
    setForm(f => ({ ...f, empresa: nombre, sucursal: '', centroCostos: '', direccion: '' }));
    if (errors.empresa) setErrors(e => ({ ...e, empresa: false }));
  };
  const handleSucursal = (s) => { set('sucursal', s); set('centroCostos', ''); };
  const handleCentro = (nombre) => {
    const centroObj = centros.find(cc => cc.nombre === nombre);
    const dir = centroObj?.seccion?.trim() || centroObj?.direccion?.trim() || '';
    setForm(f => ({ ...f, centroCostos: nombre, ...(dir ? { direccion: dir } : {}) }));
    if (errors.centroCostos) setErrors(e => ({ ...e, centroCostos: false }));
  };
  const [plantillas, setPlantillas] = useState([]);
  const [plantillaModal, setPlantillaModal] = useState(false);
  const [guardarPlantillaModal, setGuardarPlantillaModal] = useState(false);
  const [nombrePlantilla, setNombrePlantilla] = useState('');

  const cargarPlantillas = useCallback(async () => {
    try { setPlantillas(await api.get('/plantillas')); } catch {}
  }, []);

  useEffect(() => { cargarPlantillas(); }, [cargarPlantillas]);

  const aplicarPlantilla = (p) => {
    setForm(f => ({
      ...f,
      empresa: p.empresa || f.empresa,
      sucursal: p.sucursal || '',
      centroCostos: p.centroCostos || '',
      direccion: p.direccion || '',
      proveedor: p.proveedor || '',
      banco: p.banco || '',
      clabe: p.clabe || '',
      cuenta: p.cuenta || '',
      moneda: p.moneda || 'MXN',
      formaPago: p.formaPago || 'TRANSFERENCIA ELECTRÓNICA',
      tipoPago: p.tipoPago || 'Programado',
      motivoPago: p.motivoPago || '',    }));
    setPlantillaModal(false);
    toast_(`Plantilla "${p.nombre}" aplicada`);
  };

  const guardarComoPlantilla = async () => {
    if (!nombrePlantilla.trim()) return;
    try {
      await api.post('/plantillas', {
        nombre: nombrePlantilla.trim(),
        empresa: form.empresa, sucursal: form.sucursal, centroCostos: form.centroCostos,
        direccion: form.direccion, proveedor: form.proveedor, banco: form.banco,
        clabe: form.clabe, cuenta: form.cuenta, moneda: form.moneda,
        formaPago: form.formaPago, tipoPago: form.tipoPago,
        motivoPago: form.motivoPago,
      });
      toast_(`Plantilla "${nombrePlantilla.trim()}" guardada`);
      setNombrePlantilla('');
      setGuardarPlantillaModal(false);
      cargarPlantillas();
    } catch (e) { toast_(e.message, 'error'); }
  };

  const eliminarPlantilla = async (id) => {
    if (!window.confirm('¿Eliminar esta plantilla?')) return;
    try { await api.del(`/plantillas/${id}`); cargarPlantillas(); } catch {}
  };

  const handleProveedor = (p) => {
    setForm(f => ({
      ...f,
      proveedor: p ? p.nombre : '',
      rfcProveedor: p?.rfc || '',
      banco: p?.banco || '',
      clabe: p?.clabe || '',
      cuenta: p?.cuenta || '',
      moneda: p?.moneda || 'MXN',
    }));
    if (p && errors.proveedor) setErrors(e => ({ ...e, proveedor: false }));
  };

  const validate = () => {
    const e = {};
    if (!form.empresa) e.empresa = true;
    if (!form.sucursal) e.sucursal = true;
    if (!form.centroCostos) e.centroCostos = true;
    if (!form.proveedor) e.proveedor = true;
    if (form.observaciones.trim().length < 50) e.observaciones = true; // concepto detallado: mínimo 50 caracteres
    const invalidos = conceptos.length === 0 ||
      conceptos.some(c => !c.motivo?.trim() || !c.monto || isNaN(parseFloat(c.monto)) || parseFloat(c.monto) <= 0);
    if (invalidos) e.conceptos = true;
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const toast_ = (msg, tipo = 'ok') => { setToast({ msg, tipo }); setTimeout(() => setToast(null), 4000); };

  const buildPayload = () => {
    const items = conceptos.map(c => ({ motivo: c.motivo.trim(), monto: parseFloat(c.monto) || 0, operacion: c.operacion }));
    // motivoPago (requerido por el modelo) resume los conceptos para el historial/reporte
    const motivoResumen = items.length === 1 ? items[0].motivo : `Finiquito (${items.length} conceptos)`;
    return { ...form, monto: totalBase, motivoPago: motivoResumen, conceptosNomina: items, facturas: [], impuestos: [], impuestosImportes: {} };
  };

  const resetCampos = () => {
    setConceptos([{ motivo: '', monto: '', operacion: 'suma' }]);
    setAdjuntos([]);
    setForm(f => ({ ...f, observaciones: '' }));
  };

  const handleGuardar = async () => {
    if (!validate()) { toast_('Completa los campos requeridos', 'error'); return; }
    setLoading(true);
    try {
      const sol = await api.post('/finiquitos', buildPayload());
      await subirAdjuntos(sol._id);
      toast_(`✅ Finiquito ${sol.folio} guardada`);
      if (onCreated) onCreated();
      resetCampos();
    } catch (e) { toast_(e.message, 'error'); }
    finally { setLoading(false); }
  };

  const handlePDF = async () => {
    if (!validate()) { toast_('Completa los campos requeridos', 'error'); return; }
    setLoading(true);
    try {
      const sol = await api.post('/finiquitos', buildPayload());
      await subirAdjuntos(sol._id);
      const blob = await api.downloadPdf(`/finiquitos/${sol._id}/pdf`);
      const url = URL.createObjectURL(blob);
      Object.assign(document.createElement('a'), { href: url, download: `Finiquito_${sol.folio}.pdf` }).click();
      URL.revokeObjectURL(url);
      toast_(`✅ Finiquito ${sol.folio} generada`);
      if (onCreated) onCreated();
    } catch (e) { toast_(e.message, 'error'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      <Toast msg={toast?.msg} tipo={toast?.tipo} onClose={() => setToast(null)} />

      <PageHeader
        icon="📝"
        title="Solicitud de Pago de Finiquitos"
        subtitle={`SS-CPP-P-01-F01 · Versión 3 · ${user?.nombre}`}
        actions={
          <>
            <button onClick={() => setPlantillaModal(true)}
              style={{ ...css.btnGhost, border: '1px solid var(--hair)', fontSize: 12 }}>📂 Plantillas</button>
            <button onClick={() => setGuardarPlantillaModal(true)}
              style={{ ...css.btnGhost, border: '1px solid var(--hair)', fontSize: 12 }}>💾 Guardar plantilla</button>
            <button onClick={() => { setErrors({}); setConceptos([{ motivo: '', monto: '', operacion: 'suma' }]); setAdjuntos([]); setForm(f => ({ ...f, empresa: '', sucursal: '', centroCostos: '', direccion: '', proveedor: '', banco: '', clabe: '', cuenta: '', motivoPago: '', observaciones: '' })); }}
              style={{ ...css.btnGhost, border: '1px solid var(--hair)', fontSize: 12 }}>Limpiar</button>
            <button onClick={handleGuardar} disabled={loading}
              style={{ ...css.btn('rgba(255,255,255,0.9)', false), color: 'var(--ink)', fontSize: 12 }}>
              {loading ? '...' : '💾 Guardar'}
            </button>
            <button onClick={handlePDF} disabled={loading}
              style={{ ...css.btn(accent), boxShadow: `0 4px 14px rgba(255,84,28,0.30)`, fontSize: 12, minWidth: 130 }}>
              {loading ? 'Generando...' : '⬇️ Guardar y PDF'}
            </button>
          </>
        }
      />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 20 }}>
        {/* Formulario */}
        <div style={{ ...css.card, padding: 28 }}>
          <SectionHeader accent={accent}>Datos Generales</SectionHeader>
          <Grid cols={2} gap={14} style={{ marginBottom: 14 }}>
            <div>
              <Label required>Compañía</Label>
              <select value={form.empresa} onChange={e => handleEmpresa(e.target.value)} style={css.select(errors.empresa)}>
                <option value="">Seleccionar empresa...</option>
                {empresas.map(e => <option key={e._id} value={e.nombre}>{e.nombre}</option>)}
              </select>
            </div>
            <div>
              <Label required>Fecha</Label>
              <input type="date" value={form.fechaSolicitud} readOnly style={{ ...css.input(false), ...css.inputRO }} />
            </div>
          </Grid>
          <Grid cols={3} gap={14} style={{ marginBottom: 14 }}>
            <div>
              <Label required>Sucursal</Label>
              <select value={form.sucursal} onChange={e => handleSucursal(e.target.value)} disabled={!form.empresa} style={css.select(errors.sucursal)}>
                <option value="">Seleccionar...</option>
                {sucursalesFiltradas.map(s => <option key={s._id} value={s.nombre}>{s.nombre}</option>)}
              </select>
            </div>
            <div>
              <Label required>Centro de Costos</Label>
              <select value={form.centroCostos} onChange={e => handleCentro(e.target.value)} disabled={!form.sucursal} style={css.select(errors.centroCostos)}>
                <option value="">Seleccionar...</option>
                {(() => {
                  const secs = [...new Set(centros.map(c => (c.seccion || c.direccion || '').trim()).filter(Boolean))];
                  const sinSec = centros.filter(c => !(c.seccion || c.direccion || '').trim());
                  return [
                    ...secs.map(sec => (
                      <optgroup key={sec} label={sec}>
                        {centros.filter(c => (c.seccion || c.direccion || '').trim() === sec).map(c => (
                          <option key={c._id} value={c.nombre}>{c.nombre}</option>
                        ))}
                      </optgroup>
                    )),
                    ...sinSec.map(c => <option key={c._id} value={c.nombre}>{c.nombre}</option>),
                  ];
                })()}
              </select>
            </div>
            <div>
              <Label>Dirección</Label>
              <select value={form.direccion} onChange={e => set('direccion', e.target.value)} style={css.select(false)}>
                <option value="">Seleccionar...</option>
                {['DIRECCION GENERAL','DIRECCION COMERCIAL','DIRECCION COMPRAS','DIRECCION JURIDICO RH',
                  'DIRECCION FINANZAS','DIRECCION UNE CRISTALERIA','DIRECCION UNE MEDICAL STORE',
                  'DIRECCION LOGISTICA','DIRECCION GOLDEN','DIRECCION PATRIMONIAL','DIRECCION FONTASTIC',
                ].map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </div>
          </Grid>

          <SectionHeader accent={accent}>Finiquito / Beneficiario</SectionHeader>
          <div style={{ marginBottom: 14 }}>
            <Label required>Buscar Finiquito</Label>
            <ProveedorSearch value={form.proveedor} onSelect={handleProveedor} />
            {errors.proveedor && <div style={{ color: 'var(--danger)', fontSize: 11, marginTop: 3 }}>Campo requerido</div>}
          </div>
          <Grid cols={3} gap={14} style={{ marginBottom: 14 }}>
            <div><Label>Banco</Label><input value={form.banco} readOnly style={{ ...css.input(false), ...css.inputRO }} /></div>
            <div>
              <Label>CLABE</Label>
              <input value={form.clabe} readOnly style={{ ...css.input(false), ...css.inputRO, fontFamily: 'Geist Mono, monospace', fontSize: 11.5 }} />
              {form.clabe && (() => {
                const r = validarCLABE(form.clabe);
                if (!r) return null;
                return (
                  <div style={{ fontSize: 11, marginTop: 3, fontWeight: 600, color: r.valida ? '#15803d' : '#dc2626' }}>
                    {r.valida ? '✓' : '✗'} {r.mensaje}
                  </div>
                );
              })()}
            </div>
            <div><Label>No. Cuenta</Label><input value={form.cuenta} readOnly style={{ ...css.input(false), ...css.inputRO, fontFamily: 'Geist Mono, monospace', fontSize: 11.5 }} /></div>
          </Grid>

          <SectionHeader accent={accent}>Datos de Pago</SectionHeader>
          <Grid cols={3} gap={14} style={{ marginBottom: 14 }}>
            <div>
              <Label>Moneda</Label>
              <select value={form.moneda} onChange={e => set('moneda', e.target.value)} style={css.select(false)}>
                <option value="MXN">MXN</option><option value="USD">USD</option><option value="EUR">EUR</option>
              </select>
            </div>
            <div>
              <Label>Forma de Pago</Label>
              <select value={form.formaPago} onChange={e => set('formaPago', e.target.value)} style={css.select(false)}>
                {['TRANSFERENCIA ELECTRÓNICA', 'CHEQUE', 'EFECTIVO', 'CONTADO', 'REFERENCIA BANCARIA'].map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div>
              <Label>Tipo</Label>
              <select value={form.tipoPago} onChange={e => set('tipoPago', e.target.value)} style={css.select(false)}>
                <option value="Programado">Programado</option>
                <option value="No Programado">No Programado</option>
              </select>
            </div>
          </Grid>

          <div style={{ marginBottom: 14 }}>
            <Label required>Motivos de Pago (suman o restan al neto)</Label>
            <ConceptosNomina conceptos={conceptos} onChange={setConceptos} motivos={motivosCatalogo} hasError={errors.conceptos} />
          </div>

          <div style={{ marginBottom: 14 }}>
            <Label>Adjuntar PDF</Label>
            <input ref={pdfInputRef} type="file" accept=".pdf,application/pdf" multiple style={{ display: 'none' }} onChange={e => handleAdjuntarPDF(e.target.files)} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <button onClick={() => pdfInputRef.current?.click()} style={{ padding: '6px 14px', borderRadius: 7, fontSize: 12, fontWeight: 600, border: '1.5px solid rgba(59,130,246,0.30)', background: 'rgba(59,130,246,0.08)', color: '#1d4ed8', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>📎 Adjuntar PDF</button>
              {adjuntos.map((f, i) => (
                <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 6, fontSize: 11, background: 'var(--panel)', border: '1px solid var(--hair)', color: 'var(--ink-soft)', maxWidth: 240 }}>
                  <span>📄</span>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                  <button onClick={() => setAdjuntos(a => a.filter((_, j) => j !== i))} title="Quitar archivo" style={{ border: 'none', background: 'transparent', color: '#ffb4ab', cursor: 'pointer', fontSize: 12, padding: 0, flexShrink: 0 }}>✕</button>
                </span>
              ))}
            </div>
            <div style={{ fontSize: 11, color: 'var(--glass)', marginTop: 4 }}>Opcional. Se guardará en el expediente al crear la solicitud.</div>
          </div>

          <div>
            <Label required>Concepto del Pago</Label>
            <textarea value={form.observaciones} onChange={e => set('observaciones', e.target.value)} rows={3}
              placeholder="Describe con detalle qué se está pagando (mínimo 50 caracteres)..."
              style={{ ...css.input(errors.observaciones), resize: 'vertical' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 3 }}>
              {errors.observaciones
                ? <span style={{ color: 'var(--danger)', fontSize: 11 }}>Mínimo 50 caracteres — describe el concepto con más detalle</span>
                : <span />}
              <span style={{ fontSize: 11, fontFamily: 'Geist Mono, monospace', color: form.observaciones.trim().length >= 50 ? '#15803d' : 'var(--glass)' }}>
                {form.observaciones.trim().length}/50
              </span>
            </div>
          </div>
        </div>

        {/* Panel resumen */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ background: 'var(--panel)', borderRadius: 14, overflow: 'hidden', border: '1px solid var(--hair)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)' }}>
            <div style={{ background: `linear-gradient(135deg, ${accent}22 0%, ${accent}08 100%)`, borderBottom: `1px solid ${accent}30`, padding: '16px 18px', transition: 'background 0.3s' }}>
              <div style={{ fontSize: 10, color: 'var(--glass)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Compañía</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)', marginTop: 3 }}>{form.empresa || '—'}</div>
            </div>
            <div style={{ padding: '14px 18px' }}>
              {[['Finiquito', form.proveedor], ['Sucursal', form.sucursal], ['Centro Costos', form.centroCostos], ['Banco', form.banco]].map(([l, v]) => (
                <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--hair-soft)' }}>
                  <span style={{ fontSize: 11, color: 'var(--glass)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{l}</span>
                  <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink)', maxWidth: 140, textAlign: 'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v || '—'}</span>
                </div>
              ))}
              {totalBase !== 0 && (() => {
                const fmt = n => `$${n.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;
                const suma  = conceptos.filter(c => c.operacion !== 'resta').reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
                const resta = conceptos.filter(c => c.operacion === 'resta').reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
                return (
                  <div style={{ marginTop: 12, paddingTop: 10, borderTop: '1px solid var(--hair)' }}>
                    <div style={{ fontSize: 10, color: 'var(--glass)', marginBottom: 4 }}>
                      {conceptos.length} concepto{conceptos.length !== 1 ? 's' : ''}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                      <span style={{ fontSize: 10, color: 'var(--ok)' }}>Percepciones</span>
                      <span style={{ fontSize: 11, color: 'var(--ok)', fontWeight: 600, fontFamily: 'Geist Mono, monospace' }}>+{fmt(suma)}</span>
                    </div>
                    {resta > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                        <span style={{ fontSize: 10, color: 'var(--danger)' }}>Deducciones</span>
                        <span style={{ fontSize: 11, color: 'var(--danger)', fontWeight: 600, fontFamily: 'Geist Mono, monospace' }}>-{fmt(resta)}</span>
                      </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, paddingTop: 6, borderTop: '1px solid var(--hair-soft)' }}>
                      <span style={{ fontSize: 10, color: 'var(--glass)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Neto a Pagar</span>
                      <div>
                        <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--plasma)', transition: 'color 0.3s', fontFamily: 'Geist Mono, monospace' }}>{fmt(totalBase)}</span>
                        <span style={{ fontSize: 11, color: 'var(--glass)', marginLeft: 4 }}>{form.moneda}</span>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>

          <button onClick={handlePDF} disabled={loading}
            style={{ ...css.btn(accent), padding: '13px', fontSize: 13.5, width: '100%', boxShadow: `0 4px 14px rgba(255,84,28,0.30)` }}>
            {loading ? 'Generando...' : '⬇️ Guardar y PDF'}
          </button>
        </div>
      </div>

      {/* Modal: cargar plantilla */}
      <Modal open={plantillaModal} onClose={() => setPlantillaModal(false)} title="Plantillas guardadas" width={460}>
        {plantillas.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--glass)', padding: '24px 0', fontSize: 13 }}>
            No tienes plantillas guardadas.<br />Rellena el formulario y usa "Guardar plantilla".
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {plantillas.map(p => (
              <div key={p._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: 'var(--hair-soft)', borderRadius: 8, border: '1px solid var(--hair)' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}>{p.nombre}</div>
                  <div style={{ fontSize: 11, color: 'var(--glass)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {[p.proveedor, p.empresa, p.motivoPago].filter(Boolean).join(' · ')}
                  </div>
                </div>
                <button onClick={() => aplicarPlantilla(p)} style={{ ...css.btn('#0369a1'), fontSize: 12, padding: '5px 12px', flexShrink: 0 }}>Aplicar</button>
                <button onClick={() => eliminarPlantilla(p._id)} style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid rgba(239,68,68,0.28)', background: 'rgba(239,68,68,0.10)', color: 'var(--danger)', cursor: 'pointer', fontSize: 12, flexShrink: 0 }}>🗑</button>
              </div>
            ))}
          </div>
        )}
      </Modal>

      {/* Modal: guardar plantilla */}
      <Modal open={guardarPlantillaModal} onClose={() => { setGuardarPlantillaModal(false); setNombrePlantilla(''); }} title="Guardar como plantilla" width={380}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ fontSize: 13, color: 'var(--glass)' }}>Se guardarán los datos del proveedor, empresa, motivo y configuración de pago (sin montos ni folios CFDI).</div>
          <input autoFocus value={nombrePlantilla} onChange={e => setNombrePlantilla(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && guardarComoPlantilla()}
            placeholder="Nombre de la plantilla..." style={css.input(!nombrePlantilla.trim())} />
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button onClick={() => { setGuardarPlantillaModal(false); setNombrePlantilla(''); }} style={{ ...css.btn('#6b7280', true), fontSize: 13 }}>Cancelar</button>
            <button onClick={guardarComoPlantilla} disabled={!nombrePlantilla.trim()} style={{ ...css.btn('#5e72e4'), fontSize: 13 }}>Guardar</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
